// Typed failure for portal API helpers. A non-OK response is never parsed
// (it may be an nginx HTML page, not JSON) and never treated as success.
export class ApiError extends Error {
  constructor(status, path) {
    super(`HTTP ${status}`);
    this.name = "ApiError";
    this.status = status;
    this.path = path;
  }
}

export async function jsonOrThrow(res, path) {
  if (!res.ok) throw new ApiError(res.status, path);
  return res.json();
}
